
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { connect } from 'react-redux';
import ConfirmDeleteFromTrashDialog from './confirm-delete-from-trash-dialog';
import TopBarMessageViewer from './top-bar-message-viewer';
import TopBarMessageEditor from './top-bar-message-editor';
import { getSelectedFolder } from '../../selectors/folders';
import { getCredentials } from '../../selectors/application';
import { findTrashFolder, FolderTypes } from '../../services/folder';
import Toolbar from './toolbar';

import {
  forwardMessage,
  replyMessage,
  replyMessageAll,
  clearSelectedMessage
} from '../../services/application';
import { resetSyncsImap } from '../../services/sync-imap';
import {
  deleteMessages,
  moveMessages,
  setMessagesSeen
} from '../../services/message';
import { setFilteredMessages } from '../../actions/application';
import { setShowFolderList } from '../../actions/folders';
import { setIsFullMessageContent, clearSelected } from '../../actions/messages';
import { runSearchAndApply } from '../../services/search-mails-flow';
import { Confirmation } from '../../components/notification/confirmation';
import MoveToPopover from './move-to-popover';
import '../../styles/main.scss';
import './top-bar.scss';

export class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deletingFromTrash: false,
      deletingFromTrashConfirm: () => {},
      showRemoveConfirmation: false,
      isRead: true,
      isPopoverId: false
    };

    this.onForwardMessage = this.onForwardMessage.bind(this);
    this.onReplyMessage = this.onReplyMessage.bind(this);
    this.onReplyAllMessage = this.onReplyAllMessage.bind(this);
  }

  handleRefreshClick = () => {
    const { application, lexon, onRefreshClick } = this.props;
    try {
      resetSyncsImap({
        ...lexon,
        user: lexon && lexon.account
      });
    } catch (error) {
      console.error('Error resetting syncs imap', error);
    }
    const hasFiltersApplied =
      application &&
      application.filtersApplied &&
      Object.keys(application.filtersApplied).length > 0;
    if (hasFiltersApplied) {
      this.props.refreshSearchMailsElastic();
    } else {
      onRefreshClick();
    }
  }

  onReplyMessage() {
    this.props.replyMessage(this.props.lexon);
  }

  onReplyAllMessage() {
    this.props.replyMessageAll(this.props.lexon);
  }

  onForwardMessage() {
    this.props.forwardMessage(this.props.lexon);
  }

  onPrint = () => {
    const messageContent = document.getElementById("message-viewer-container");
    const winPrint = window.open('', '', 'width=950,height=800');
    winPrint.document.write(messageContent.innerHTML);
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    winPrint.close();
  }

  onRemoveMessage = (deleteMessagesActions, deleteMessageAction) => {
    this.setState(
      { showRemoveConfirmation: false },
      async () => {
        if (this.props.selectedFolder.type === FolderTypes.TRASH) {
          this.setState({
            deletingFromTrash: true,
            deletingFromTrashConfirm: () => {
              if (this.props.isFullMessageContent) {
                deleteMessageAction();
              } else {
                deleteMessagesActions();
              }
              this.setState({ deletingFromTrash: false });
            }
          });
        } else {
          // Uncheck messages from Lexon
          for (let i = 0; i < this.props.selectedMessages.length; i++) {
            window.dispatchEvent(
              new CustomEvent('RemoveSelectedDocument', {
                detail: {
                  ...this.props.selectedMessages[i],
                  id: this.props.selectedMessages[i].messageId
                }
              })
            );
          }
          if (this.props.isFullMessageContent) {
            deleteMessageAction();
          } else {
            deleteMessagesActions();
          }
          this.props.onRefreshClick();
        }
      }
    );
  }

  render() {
    const {
      showRemoveConfirmation,
      deletingFromTrash,
      deletingFromTrashConfirm,
      isRead,
    } = this.state;
    const props = this.props;
    
    const {
      selectedMessages,
      selectedMessagesAllUnread,
      outbox,
      toggleMessageSeen,
      selectedMessage,
      isFrame,
      showFolderList,
      setShowFolderList,
    } = props;

    const collapsed = props.sideBarCollapsed;
    const isEditing =
      props.newMessage && Object.keys(props.newMessage).length > 0;
    const isMessageViewer =
      props.selectedMessage && Object.keys(props.selectedMessage).length > 0;
    
    return (
      <header
        className={`mb-3 topBar
      ${collapsed ? !isFrame ? 'without-side-bar' : 'without-side-bar-iframe' : 
        !isFrame ? '' : 'with-side-bar-iframe'}
          mdc-top-app-bar mdc-top-app-bar--fixed`}>
        {!isEditing && !isMessageViewer && (
          <Toolbar
            selectedMessages={selectedMessages}
            onDeleteClick={() => {
              this.onDelete();
            }}
            selectedMessagesAllUnread={selectedMessagesAllUnread}
            onMarkReadClick={() => {
              toggleMessageSeen(true);
            }}
            onMarkUnreadClick={() => {
              toggleMessageSeen(false);
            }}
            onRefreshClick={this.handleRefreshClick}
          />
        )}
        {!isEditing && isMessageViewer && (
          <TopBarMessageViewer
            selectedMessagesCounter={selectedMessages.length}
            clearSelectedMessage={() => {
              setTimeout(() => {
                window.dispatchEvent(new CustomEvent("ResetList"));
                props.clearListMessages();
              }, 500);
              props.clearSelectedMessage();
              props.setIsFullMessageContent(false);
            
            }}
            outboxEmpty={outbox === null}
            onReplyMessageClick={this.onReplyMessage}
            onReplyAllMessageClick={this.onReplyAllMessage}
            onForwardMessageClick={this.onForwardMessage}
            onPrint={() => this.onPrint()}
            onDeleteClick={() => {
              this.onDelete();
            }}
            onMarkReadClick={() => {  
              this.setState({isRead: !isRead}, () => {   
                toggleMessageSeen(selectedMessagesAllUnread);
              });
            }}
            isImportant={selectedMessage.important}
            onRefreshClick={this.handleRefreshClick}
          />
        )}
        {isEditing && (
          <TopBarMessageEditor
            submitMethod={props.submitMethod}
            addAttachmentMethod={props.addAttachmentMethod}
            addDraftMethod={props.addDraftMethod}
            close={props.close}
            draftTime={props.draftTime}
          />
        )}
        <ConfirmDeleteFromTrashDialog
          visible={deletingFromTrash}
          deleteAction={deletingFromTrashConfirm}
          cancelAction={() => this.setState({ deletingFromTrash: false })}
        />
        <Confirmation
          initialModalState={showRemoveConfirmation}
          onAccept={() => {
            this.onRemoveMessage(props.deleteMessages, props.deleteMessage);
          }}
          onCancel={() => {
            this.setState({ showRemoveConfirmation: false });
          }}
          message={i18n.t("topBar.remove-message-confirmation")}
          titleAccept="Si"
          titleCancel="No"
          iconType="lf-icon lf-icon-information"
        />
        {(!isEditing && isMessageViewer) && (
          <MoveToPopover
            showFolderList={showFolderList}
            setShowFolderList={setShowFolderList}
          />
        )}
      </header>
    );
  }

  onDelete() {
    const existIdActuation = this.props.selectedMessagesClassification.some(x => x.idActuation);
    if (existIdActuation) {
      this.setState({ showRemoveConfirmation: true });
      return;
    }
    if (this.props.selectedFolder.type === FolderTypes.TRASH) {
      this.setState({
        deletingFromTrash: true,
        deletingFromTrashConfirm: () => {
          this.props.deleteMessages();
          this.setState({ deletingFromTrash: false });
        }
      });
    } else {
      // Uncheck messages from Lexon
      for (let i = 0; i < this.props.selectedMessages.length; i++) {
        window.dispatchEvent(
          new CustomEvent('RemoveSelectedDocument', {
            detail: {
              ...this.props.selectedMessages[i],
              id: this.props.selectedMessages[i].messageId
            }
          })
        );
      }
      // Refresh once the server has finished the operation instead of using a fixed delay
      Promise.resolve(this.props.deleteMessages()).finally(() => {
        this.props.onRefreshClick();
      });
    }
  }
}

TopBar.propTypes = {
  title: PropTypes.string,
  newMessage: PropTypes.object,
  selectedFolder: PropTypes.object,
  selectedMessagesIds: PropTypes.array,
  selectedMessages: PropTypes.array,
  selectedMessage: PropTypes.object,
  selectedMessagesAllUnread: PropTypes.bool,
  clearSelectedMessage: PropTypes.func,
  sideBarToggle: PropTypes.func.isRequired,
  sideBarCollapsed: PropTypes.bool.isRequired,
  onRefreshClick: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const useFilteredMessages = state.application.filtersApplied &&
    Object.keys(state.application.filtersApplied).length > 0;
  const selectedMessagesIds = state.messages.selected;
  const messages =
    state.application.selectedFolderId &&
    state.messages.cache[state.application.selectedFolderId]
      ? Array.from(
        Object.values(state.messages.cache[state.application.selectedFolderId] || {})
      )
      : [];
  const selectedMessages = useFilteredMessages ? selectedMessagesIds : messages.filter(
    m => selectedMessagesIds.find(mIds => mIds.messageId === m.messageId && mIds.uid === m.uid)
  );
  const selectedMessagesAllUnread =
    selectedMessages.filter(m => m.seen === true).length === 0;
  return {
    application: state.application,
    newMessage: state.application.newMessage,
    outbox: state.application.outbox,
    selectedFolder: getSelectedFolder(state) || null,
    selectedMessagesIds: selectedMessagesIds,
    selectedMessages: selectedMessages,
    allSelectedMessages: state.messages.selected,
    selectedMessage: state.application.selectedMessage,
    selectedMessagesAllUnread: selectedMessagesAllUnread,
    credentials: getCredentials(state),
    folders: state.folders,
    showFolderList: state.folders.showFolderList,
    lexon: state.lexon,
    messages: messages,
    selectedMessagesClassification: state.messages.selectedMessages,
    isFullMessageContent: state.messages.isFullMessageContent
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  clearSelectedMessage: () => clearSelectedMessage(dispatch),
  setShowFolderList: showFolderList => dispatch(setShowFolderList(showFolderList)),
  clearListMessages: () => dispatch(clearSelected()),
  setIsFullMessageContent: isFullMessageContent => dispatch(setIsFullMessageContent(isFullMessageContent)),
  replyMessage: (selectedMessaage, sign) =>
    replyMessage(dispatch, selectedMessaage, sign),
  replyMessageAll: (selectedMessaage, sign) =>
    replyMessageAll(dispatch, selectedMessaage, sign),
  forwardMessage: (selectedMessaage, sign) =>
    forwardMessage(dispatch, selectedMessaage, sign),
  deleteMessage: (credentials, folders, selectedFolder, selectedMessage, user, lexon) => {
    const trashFolder = findTrashFolder(folders);
    if (selectedMessage && selectedFolder && trashFolder) {
      if (selectedFolder === trashFolder) {
        deleteMessages(
          dispatch,
          credentials,
          selectedFolder,
          [selectedMessage],
          lexon
        );
      } else {
        moveMessages(
          dispatch,
          credentials,
          selectedFolder,
          trashFolder,
          [selectedMessage],
          user,
          lexon
        );
      }
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("ResetList"));
        dispatch(clearSelected());
      }, 500);
      clearSelectedMessage(dispatch);
      dispatch(setIsFullMessageContent(false));
    }
  },
  toggleMessageSeen: (
    credentials,
    folders,
    selectedFolder,
    selectedMessages,
    isFullMessageContent,
    seen,
    filteredMessages,
    filtersApplied
  ) => {
    if (!selectedMessages || selectedMessages.length === 0) {
      return;
    }

    const exploded = folders && folders.explodedItems ? folders.explodedItems : {};
    const groups = {};

    selectedMessages.forEach(m => {
      const folderId = m.folderId || (selectedFolder && selectedFolder.folderId);
      if (!folderId) {
        return;
      }
      if (!groups[folderId]) {
        groups[folderId] = [];
      }
      groups[folderId].push(m);
    });

    Object.keys(groups).forEach(folderId => {
      const inSelectedFolder = selectedFolder && selectedFolder.folderId === folderId;
      let folderObj = null;
      if (exploded && exploded[folderId]) {
        folderObj = exploded[folderId];
      } else if (inSelectedFolder) {
        folderObj = selectedFolder;
      }
      if (!folderObj) {
        return;
      }
      setMessagesSeen(
        dispatch,
        credentials,
        folderObj,
        groups[folderId],
        seen
      );
    });

    // If in filtered mode, update filtered list items' seen flag locally
    const hasFilters = filtersApplied && Object.keys(filtersApplied).length > 0;
    if (hasFilters && Array.isArray(filteredMessages) && filteredMessages.length > 0) {
      const selectedUidSet = new Set(
        selectedMessages
          .map(m => {
            if (!m) {
              return null;
            }
            if (typeof m.uid === 'undefined' || m.uid === null) {
              return null;
            }
            return String(m.uid);
          })
          .filter(v => v !== null)
      );

      const selectedMessageIdSet = new Set(
        selectedMessages
          .map(m => {
            if (!m) {
              return null;
            }
            if (typeof m.messageId === 'undefined' || m.messageId === null) {
              return null;
            }
            return String(m.messageId);
          })
          .filter(v => v !== null)
      );

      const updated = filteredMessages.map(item => {
        const md = item && item.metadata ? item.metadata : {};
        let idCandidate = null;
        if (typeof md.idExternal !== 'undefined' && md.idExternal !== null) {
          idCandidate = String(md.idExternal);
        } else if (typeof md.id !== 'undefined' && md.id !== null) {
          idCandidate = String(md.id);
        }
        let msgIdCandidate = null;
        if (typeof md.messageId !== 'undefined' && md.messageId !== null) {
          msgIdCandidate = String(md.messageId);
        }

        const matchesUid = idCandidate !== null && selectedUidSet.has(idCandidate);
        const matchesMsgId = msgIdCandidate !== null && selectedMessageIdSet.has(msgIdCandidate);

        if (matchesUid || matchesMsgId) {
          return {
            ...item,
            metadata: {
              ...md,
              seen: !!seen
            }
          };
        }
        return item;
      });
      dispatch(setFilteredMessages(updated));
    }

    if (isFullMessageContent) {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("ResetList"));
        dispatch(clearSelected());
      }, 500);
      dispatch(setIsFullMessageContent(false));
      clearSelectedMessage(dispatch);
    }
  },
  deleteMessages: (credentials, folders, selectedFolder, selectedMessages, user, lexon, application) => {
    const trashFolder = findTrashFolder(folders);
    if (!trashFolder || !selectedMessages || selectedMessages.length === 0) {
      return;
    }

    const exploded = folders && folders.explodedItems ? folders.explodedItems : {};
    const hasFilters = application && application.filtersApplied &&
      Object.keys(application.filtersApplied).length > 0;
    const filteredMessages = hasFilters && Array.isArray(application.filteredMessages)
      ? application.filteredMessages
      : [];
    const uidByMessageId = new Map(
      filteredMessages
        .map(item => {
          const md = item && item.metadata ? item.metadata : {};
          const msgId = (typeof md.messageId !== 'undefined' && md.messageId !== null) ? String(md.messageId) : null;
          const idExt = (typeof md.idExternal !== 'undefined' && md.idExternal !== null) ? String(md.idExternal) : null;
          if (msgId !== null && idExt !== null) {
            return [msgId, idExt];
          }
          return null;
        })
        .filter(e => e !== null)
    );

    const normalized = selectedMessages.map(m => {
      let uid = m && typeof m.uid !== 'undefined' && m.uid !== null ? m.uid : null;
      if ((uid === null || isNaN(Number(uid))) && m && typeof m.messageId !== 'undefined' && m.messageId !== null) {
        const found = uidByMessageId.get(String(m.messageId));
        if (found) {
          uid = Number(found);
        }
      }
      return { ...m, uid };
    });

    const groups = {};
    normalized.forEach(m => {
      const folderId = m.folderId || (selectedFolder && selectedFolder.folderId);
      if (!folderId) {
        return;
      }
      if (!groups[folderId]) {
        groups[folderId] = [];
      }
      groups[folderId].push(m);
    });

    const pending = [];
    Object.keys(groups).forEach(folderId => {
      const inSelectedFolder = selectedFolder && selectedFolder.folderId === folderId;
      let fromFolder = null;
      if (exploded && exploded[folderId]) {
        fromFolder = exploded[folderId];
      } else if (inSelectedFolder) {
        fromFolder = selectedFolder;
      }
      if (!fromFolder) {
        return;
      }
      if (fromFolder.folderId === trashFolder.folderId) {
        pending.push(deleteMessages(dispatch, credentials, fromFolder, groups[folderId], lexon));
      } else {
        pending.push(moveMessages(
          dispatch,
          credentials,
          fromFolder,
          trashFolder,
          groups[folderId],
          user,
          lexon
        ));
      }
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("ResetList"));
        dispatch(clearSelected());
      }, 500);
      clearSelectedMessage(dispatch);
      dispatch(setIsFullMessageContent(false));
    });
    // Update filtered list by removing deleted items if filters are applied
    if (hasFilters && filteredMessages.length > 0) {
      const uidSet = new Set(
        normalized
          .map(m => {
            if (typeof m.uid === 'undefined' || m.uid === null) {
              return null;
            }
            return String(m.uid);
          })
          .filter(v => v !== null)
      );
      const msgIdSet = new Set(
        normalized
          .map(m => {
            if (typeof m.messageId === 'undefined' || m.messageId === null) {
              return null;
            }
            return String(m.messageId);
          })
          .filter(v => v !== null)
      );

      const updatedFiltered = filteredMessages.filter(item => {
        const md = item && item.metadata ? item.metadata : {};
        let idCandidate = null;
        if (typeof md.idExternal !== 'undefined' && md.idExternal !== null) {
          idCandidate = String(md.idExternal);
        } else if (typeof md.id !== 'undefined' && md.id !== null) {
          idCandidate = String(md.id);
        }
        const msgIdCandidate = (typeof md.messageId !== 'undefined' && md.messageId !== null)
          ? String(md.messageId)
          : null;
        const matchesUid = idCandidate !== null && uidSet.has(idCandidate);
        const matchesMsgId = msgIdCandidate !== null && msgIdSet.has(msgIdCandidate);
        return !(matchesUid || matchesMsgId);
      });
      dispatch(setFilteredMessages(updatedFiltered));
    }
    return Promise.all(pending);
  },
  refreshSearchMailsElastic: async (body, userId, account, lexonToken) => {
    try {
      await runSearchAndApply(dispatch, { userId, account, lexonToken, body });
    } catch (error) {
      console.error('Error refreshing Elastic search', error);
    }
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps, {
    replyMessage: sign =>
      dispatchProps.replyMessage(stateProps.selectedMessage, sign),
    replyMessageAll: sign =>
      dispatchProps.replyMessageAll(stateProps.selectedMessage, sign),
    forwardMessage: sign =>
      dispatchProps.forwardMessage(stateProps.selectedMessage, sign),
    deleteMessage: () =>
      dispatchProps.deleteMessage(
        stateProps.credentials,
        stateProps.folders,
        stateProps.selectedFolder,
        stateProps.selectedMessage,
        stateProps.application.user,
        stateProps.lexon,
      ),
    toggleMessageSeen: seen =>
      dispatchProps.toggleMessageSeen(
        stateProps.credentials,
        stateProps.folders,
        stateProps.selectedFolder,
        stateProps.allSelectedMessages,
        stateProps.isFullMessageContent,
        seen,
        stateProps.application.filteredMessages,
        stateProps.application.filtersApplied
      ),
    deleteMessages: () =>
      dispatchProps.deleteMessages(
        stateProps.credentials,
        stateProps.folders,
        stateProps.selectedFolder,
        stateProps.allSelectedMessages,
        stateProps.application.user,
        stateProps.lexon,
        stateProps.application
      ),
    refreshSearchMailsElastic: () => {
      const fa = stateProps.application && stateProps.application.filtersApplied
        ? stateProps.application.filtersApplied
        : {};
      const { userId, account, lexonToken } = stateProps.lexon || {};
      if (!fa || Object.keys(fa).length === 0 || !userId || !account) {
        return;
      }
      dispatchProps.refreshSearchMailsElastic(fa, userId, account, lexonToken);
    }
  });

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(TopBar);
